import { Button, Grid } from '@material-ui/core';
import styled from 'styled-components';
import { AcceptOfferModal } from '../../../../../components/Offers';
import { useDispatch } from 'react-redux';
import { modalsToggle } from '../../../../../actions';
import { Divider } from '@material-ui/core';
import { BuyNowModal } from '../../../../Buyer/BidsList/components/BuyNowModal';
import { formatCurrency } from 'utils';

const Label = styled.span`
  color: #212121;
  font-size: 18px;
  font-weight: 500;
`;

const StyledDivider = styled(Divider)`
  && {
    margin: 24px 0;
  }
`;

const AcceptButton = styled(Button)`
  border-radius: 6px;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  width: 100%;
  height: 44px;
  cursor: pointer;
  background: #225a91;
  color: #fff;

  &:hover {
    background: #225a91;
  }

  @media (max-width: 960px) {
    width: 100%;
    margin-top: 8px;
  }
`;

export const BuyNowSection = ({ vehicle }) => {
  const dispatch = useDispatch();

  if (vehicle.in_battle || !vehicle.active_alternative_offer) return null;

  const handleAccept = () => dispatch(modalsToggle(`buyNowModal-${vehicle.id}`));

  return (
    <>
      <Grid container justify="space-between" alignItems="center">
        <AcceptButton onClick={handleAccept}>{`Buy now for ${formatCurrency(
          vehicle.active_alternative_offer.amount
        )}`}</AcceptButton>
        <BuyNowModal currentVehicle={vehicle} />
      </Grid>
    </>
  );
};
